import { getApiActionTypes } from '../storeHelpers';

export const fetchGenericCategoryTypes = getApiActionTypes('FETCH_GENERIC_CATEGORY');
export const updateGenericCategoryTypes = getApiActionTypes('UPDATE_GENERIC_CATEGORY');
